import React from 'react'
import styled from 'styled-components'
import Link from 'next/link'
import BuyButton from '../../MwPage/components/BuyButton'
import PriceBlock from '../../MwPage/components/PriceBlock'
import { useRevealProps } from '../../MwPage/components/Reveal'
import RichText from '../../MwPage/components/RichText'
import { IDS } from '../../MwPage/content'
import { Eyebrow, Hi, ice2, iceLine, ink, Lede, sans, Section, SectionHead, Small, Stack } from '../../MwPage/styled'
import TrialPriceCard from '../components/TrialPriceCard'
import { fillTrial } from '../content/trial'
import { useFocus } from '../focus'
import { Card, Column, Grid, H2, Wrap } from '../styled'

// the prototype's .offer: the price card under the six items
const OfferCard = styled.aside`
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: clamp(22px, 3vw, 32px);
  border-radius: 28px;
  background: ${ice2};
  border: 2px solid ${iceLine};

  > p:first-child {
    margin: 0;
    font: 800 22px/1.2 ${sans};
    letter-spacing: -0.02em;
    color: ${ink};
  }
`

// each item reveals on its own
const Item = ({ item }) => (
  <Card {...useRevealProps()}>
    <h3>{item.title}</h3>
    <p>
      <RichText text={item.text} />
    </p>
  </Card>
)

const StandardCard = ({ prices }) => {
  const { offer } = useFocus()
  return (
    <OfferCard aria-label={offer.card.label} {...useRevealProps()}>
      <p>{offer.card.title}</p>
      <PriceBlock offer={prices} column />
      <BuyButton $block>{offer.card.cta}</BuyButton>
      <Small>
        {offer.card.terms[0]}
        <Link href="/terms">
          <a>{offer.card.terms[1]}</a>
        </Link>
        {offer.card.terms[2]}
      </Small>
    </OfferCard>
  )
}

const TrialCard = ({ prices }) => (
  <div {...useRevealProps()}>
    <TrialPriceCard offer={prices} />
  </div>
)

/** "Next intake offer": what the month includes, where a page lists it, then the price card whose button opens the intake modal. */
const OfferSection = ({ offer: prices }) => {
  const { offer, trial } = useFocus()

  return (
    <Section $ice id={IDS.offer}>
      <Wrap>
        <Stack $gap="clamp(24px, 3vw, 32px)">
          <SectionHead>
            <Eyebrow {...useRevealProps()}>{offer.eyebrow}</Eyebrow>
            <H2 {...useRevealProps()}>
              {offer.headline} <Hi>{trial ? fillTrial(offer.headlineAccent, prices, '…') : offer.headlineAccent}</Hi>
            </H2>
            <Lede {...useRevealProps()}>{trial ? fillTrial(offer.lede, prices, '…') : offer.lede}</Lede>
          </SectionHead>
          {offer.stack && (
            <Grid $min={300}>
              {offer.stack.map((item) => (
                <Item key={item.title} item={item} />
              ))}
            </Grid>
          )}
          <Column>{trial ? <TrialCard prices={prices} /> : <StandardCard prices={prices} />}</Column>
        </Stack>
      </Wrap>
    </Section>
  )
}

export default OfferSection
